import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgTheDailyMillion = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="The-daily-million_svg__Logo"
      viewBox="0 0 250 250"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <defs>
        <radialGradient
          id="The-daily-million_svg__radial-gradient"
          cx={78.06}
          cy={5488.11}
          r={125}
          fx={78.06}
          fy={5488.11}
          gradientTransform="scale(1 -1)rotate(-1.16 -277157.11 338.835)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.53} stopColor="#fff" />
          <stop offset={0.55} stopColor="#fff" stopOpacity={0.82} />
          <stop offset={0.57} stopColor="#fff" stopOpacity={0.65} />
          <stop offset={0.6} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.63} stopColor="#fff" stopOpacity={0.36} />
          <stop offset={0.66} stopColor="#fff" stopOpacity={0.25} />
          <stop offset={0.7} stopColor="#fff" stopOpacity={0.16} />
          <stop offset={0.74} stopColor="#fff" stopOpacity={0.09} />
          <stop offset={0.79} stopColor="#fff" stopOpacity={0.04} />
          <stop offset={0.85} stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-2"
          cx={78.06}
          cy={5488.11}
          r={125}
          fx={78.06}
          fy={5488.11}
          gradientTransform="scale(1 -1)rotate(-1.16 -277157.11 338.835)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.16} stopColor="#fff" stopOpacity={0.75} />
          <stop offset={0.33} stopColor="#fff" stopOpacity={0.52} />
          <stop offset={0.49} stopColor="#fff" stopOpacity={0.34} />
          <stop offset={0.64} stopColor="#fff" stopOpacity={0.19} />
          <stop offset={0.78} stopColor="#fff" stopOpacity={0.09} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0.02} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-3"
          cx={78.06}
          cy={5488.11}
          r={125}
          fx={78.06}
          fy={5488.11}
          gradientTransform="scale(1 -1)rotate(-1.16 -277157.11 338.835)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.16} stopColor="#fff" stopOpacity={0.75} />
          <stop offset={0.33} stopColor="#fff" stopOpacity={0.52} />
          <stop offset={0.49} stopColor="#fff" stopOpacity={0.34} />
          <stop offset={0.64} stopColor="#fff" stopOpacity={0.19} />
          <stop offset={0.78} stopColor="#fff" stopOpacity={0.09} />
          <stop offset={0.9} stopColor="#fff" stopOpacity={0.02} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-4"
          cx={-4347.46}
          cy={3537.58}
          r={10.37}
          fx={-4347.46}
          fy={3537.58}
          gradientTransform="scale(-.98 .98)rotate(56.4 857.75 5729.874)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.06} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.21} stopColor="#fff" stopOpacity={0.66} />
          <stop offset={0.36} stopColor="#fff" stopOpacity={0.46} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.29} />
          <stop offset={0.64} stopColor="#fff" stopOpacity={0.16} />
          <stop offset={0.77} stopColor="#fff" stopOpacity={0.07} />
          <stop offset={0.89} stopColor="#fff" stopOpacity={0.02} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-5"
          cx={-4347.46}
          cy={3537.58}
          r={7.13}
          fx={-4347.46}
          fy={3537.58}
          gradientTransform="scale(-.98 .98)rotate(56.4 857.75 5729.874)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.08} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.27} stopColor="#fff" stopOpacity={0.62} />
          <stop offset={0.46} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.63} stopColor="#fff" stopOpacity={0.23} />
          <stop offset={0.78} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.91} stopColor="#fff" stopOpacity={0.03} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-6"
          cx={-3672.79}
          cy={1518.89}
          r={10.39}
          fx={-3672.79}
          fy={1518.89}
          gradientTransform="scale(-.98 .98)rotate(11.4 4616.104 18561.813)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.06} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.21} stopColor="#fff" stopOpacity={0.66} />
          <stop offset={0.36} stopColor="#fff" stopOpacity={0.46} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.29} />
          <stop offset={0.64} stopColor="#fff" stopOpacity={0.16} />
          <stop offset={0.77} stopColor="#fff" stopOpacity={0.07} />
          <stop offset={0.89} stopColor="#fff" stopOpacity={0.02} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-7"
          cx={-3672.77}
          cy={1518.89}
          r={7.13}
          fx={-3672.77}
          fy={1518.89}
          gradientTransform="scale(-.98 .98)rotate(11.4 4616.104 18561.813)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.08} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.27} stopColor="#fff" stopOpacity={0.62} />
          <stop offset={0.46} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.63} stopColor="#fff" stopOpacity={0.23} />
          <stop offset={0.78} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.91} stopColor="#fff" stopOpacity={0.03} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-8"
          cx={-2815.06}
          cy={854.3}
          r={10.37}
          fx={-2815.06}
          fy={854.3}
          gradientTransform="scale(-.98 .98)rotate(-11.1 -4745.578 -13401.077)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.06} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.21} stopColor="#fff" stopOpacity={0.66} />
          <stop offset={0.36} stopColor="#fff" stopOpacity={0.46} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.29} />
          <stop offset={0.64} stopColor="#fff" stopOpacity={0.16} />
          <stop offset={0.77} stopColor="#fff" stopOpacity={0.07} />
          <stop offset={0.89} stopColor="#fff" stopOpacity={0.02} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-9"
          cx={-2815.03}
          cy={854.3}
          r={7.13}
          fx={-2815.03}
          fy={854.3}
          gradientTransform="scale(.98 -.98)rotate(79.93 -713.764 2066.624)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.08} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.27} stopColor="#fff" stopOpacity={0.62} />
          <stop offset={0.46} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.63} stopColor="#fff" stopOpacity={0.23} />
          <stop offset={0.78} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.91} stopColor="#fff" stopOpacity={0.03} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-10"
          cx={-691.83}
          cy={705.14}
          r={10.37}
          fx={-691.83}
          fy={705.14}
          gradientTransform="scale(-.98 .98)rotate(-56.1 -867.005 -158.737)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.06} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.21} stopColor="#fff" stopOpacity={0.66} />
          <stop offset={0.36} stopColor="#fff" stopOpacity={0.46} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.29} />
          <stop offset={0.64} stopColor="#fff" stopOpacity={0.16} />
          <stop offset={0.77} stopColor="#fff" stopOpacity={0.07} />
          <stop offset={0.89} stopColor="#fff" stopOpacity={0.02} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-11"
          cx={-691.83}
          cy={705.13}
          r={7.13}
          fx={-691.83}
          fy={705.13}
          gradientTransform="scale(-.98 .98)rotate(-56.1 -866.937 -158.725)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.08} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.27} stopColor="#fff" stopOpacity={0.62} />
          <stop offset={0.46} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.63} stopColor="#fff" stopOpacity={0.23} />
          <stop offset={0.78} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.91} stopColor="#fff" stopOpacity={0.03} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-12"
          cx={250.4}
          cy={1243.25}
          r={10.37}
          fx={250.4}
          fy={1243.25}
          gradientTransform="scale(-.98 .98)rotate(-78.6 -565.081 872.082)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.06} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.21} stopColor="#fff" stopOpacity={0.66} />
          <stop offset={0.36} stopColor="#fff" stopOpacity={0.46} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.29} />
          <stop offset={0.64} stopColor="#fff" stopOpacity={0.16} />
          <stop offset={0.77} stopColor="#fff" stopOpacity={0.07} />
          <stop offset={0.89} stopColor="#fff" stopOpacity={0.02} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-13"
          cx={250.4}
          cy={1243.25}
          r={7.13}
          fx={250.4}
          fy={1243.25}
          gradientTransform="scale(-.98 .98)rotate(-78.6 -565.081 872.082)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.08} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.27} stopColor="#fff" stopOpacity={0.62} />
          <stop offset={0.46} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.63} stopColor="#fff" stopOpacity={0.23} />
          <stop offset={0.78} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.91} stopColor="#fff" stopOpacity={0.03} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-14"
          cx={1200.75}
          cy={3147.75}
          r={10.37}
          fx={1200.75}
          fy={3147.75}
          gradientTransform="scale(.98 -.98)rotate(56.4 3638.606 464.518)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.06} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.21} stopColor="#fff" stopOpacity={0.66} />
          <stop offset={0.36} stopColor="#fff" stopOpacity={0.46} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.29} />
          <stop offset={0.64} stopColor="#fff" stopOpacity={0.16} />
          <stop offset={0.77} stopColor="#fff" stopOpacity={0.07} />
          <stop offset={0.89} stopColor="#fff" stopOpacity={0.02} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-15"
          cx={1200.75}
          cy={3147.75}
          r={7.13}
          fx={1200.75}
          fy={3147.75}
          gradientTransform="scale(.98 -.98)rotate(56.4 3638.606 464.518)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.08} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.27} stopColor="#fff" stopOpacity={0.62} />
          <stop offset={0.46} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.63} stopColor="#fff" stopOpacity={0.23} />
          <stop offset={0.78} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.91} stopColor="#fff" stopOpacity={0.03} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-16"
          cx={1064.17}
          cy={4224.2}
          r={10.37}
          fx={1064.17}
          fy={4224.2}
          gradientTransform="scale(.98 -.98)rotate(33.9 7596.36 467.238)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.06} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.21} stopColor="#fff" stopOpacity={0.66} />
          <stop offset={0.36} stopColor="#fff" stopOpacity={0.46} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.29} />
          <stop offset={0.64} stopColor="#fff" stopOpacity={0.16} />
          <stop offset={0.77} stopColor="#fff" stopOpacity={0.07} />
          <stop offset={0.89} stopColor="#fff" stopOpacity={0.02} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-17"
          cx={1064.17}
          cy={4224.2}
          r={7.13}
          fx={1064.17}
          fy={4224.2}
          gradientTransform="scale(.98 -.98)rotate(33.9 7596.36 467.238)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.08} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.27} stopColor="#fff" stopOpacity={0.62} />
          <stop offset={0.46} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.63} stopColor="#fff" stopOpacity={0.23} />
          <stop offset={0.78} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.91} stopColor="#fff" stopOpacity={0.03} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-18"
          cx={526.05}
          cy={5166.44}
          r={10.38}
          fx={526.05}
          fy={5166.44}
          gradientTransform="scale(.98 -.98)rotate(11.4 26426.858 480.147)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.06} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.21} stopColor="#fff" stopOpacity={0.66} />
          <stop offset={0.36} stopColor="#fff" stopOpacity={0.46} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.29} />
          <stop offset={0.64} stopColor="#fff" stopOpacity={0.16} />
          <stop offset={0.77} stopColor="#fff" stopOpacity={0.07} />
          <stop offset={0.89} stopColor="#fff" stopOpacity={0.02} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-19"
          cx={526.05}
          cy={5166.44}
          r={7.13}
          fx={526.05}
          fy={5166.44}
          gradientTransform="scale(.98 -.98)rotate(11.4 26426.858 480.147)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.08} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.27} stopColor="#fff" stopOpacity={0.62} />
          <stop offset={0.46} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.63} stopColor="#fff" stopOpacity={0.23} />
          <stop offset={0.78} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.91} stopColor="#fff" stopOpacity={0.03} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-20"
          cx={-331.68}
          cy={5831}
          r={10.37}
          fx={-331.68}
          fy={5831}
          gradientTransform="scale(.98 -.98)rotate(-11.1 -30336.097 441.15)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.06} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.21} stopColor="#fff" stopOpacity={0.66} />
          <stop offset={0.36} stopColor="#fff" stopOpacity={0.46} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.29} />
          <stop offset={0.64} stopColor="#fff" stopOpacity={0.16} />
          <stop offset={0.77} stopColor="#fff" stopOpacity={0.07} />
          <stop offset={0.89} stopColor="#fff" stopOpacity={0.02} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-21"
          cx={-331.62}
          cy={5831.02}
          r={7.13}
          fx={-331.62}
          fy={5831.02}
          gradientTransform="scale(.98 -.98)rotate(-11.1 -30336.146 442.206)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.08} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.27} stopColor="#fff" stopOpacity={0.62} />
          <stop offset={0.46} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.63} stopColor="#fff" stopOpacity={0.23} />
          <stop offset={0.78} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.91} stopColor="#fff" stopOpacity={0.03} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-22"
          cx={-1378.45}
          cy={6116.77}
          r={10.37}
          fx={-1378.45}
          fy={6116.77}
          gradientTransform="scale(.98 -.98)rotate(-33.6 -10830.717 454.597)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.06} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.21} stopColor="#fff" stopOpacity={0.66} />
          <stop offset={0.36} stopColor="#fff" stopOpacity={0.46} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.29} />
          <stop offset={0.64} stopColor="#fff" stopOpacity={0.16} />
          <stop offset={0.77} stopColor="#fff" stopOpacity={0.07} />
          <stop offset={0.89} stopColor="#fff" stopOpacity={0.02} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-23"
          cx={-1378.43}
          cy={6116.78}
          r={7.13}
          fx={-1378.43}
          fy={6116.78}
          gradientTransform="scale(.98 -.98)rotate(-33.6 -10830.708 454.692)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.08} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.27} stopColor="#fff" stopOpacity={0.62} />
          <stop offset={0.46} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.63} stopColor="#fff" stopOpacity={0.23} />
          <stop offset={0.78} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.91} stopColor="#fff" stopOpacity={0.03} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-24"
          cx={-2454.89}
          cy={5980.2}
          r={10.37}
          fx={-2454.89}
          fy={5980.2}
          gradientTransform="scale(.98 -.98)rotate(-56.1 -6819.03 457.352)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.06} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.21} stopColor="#fff" stopOpacity={0.66} />
          <stop offset={0.36} stopColor="#fff" stopOpacity={0.46} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.29} />
          <stop offset={0.64} stopColor="#fff" stopOpacity={0.16} />
          <stop offset={0.77} stopColor="#fff" stopOpacity={0.07} />
          <stop offset={0.89} stopColor="#fff" stopOpacity={0.02} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-25"
          cx={-2454.82}
          cy={5980.22}
          r={7.13}
          fx={-2454.82}
          fy={5980.22}
          gradientTransform="scale(.98 -.98)rotate(-56.1 -6819.016 457.556)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.08} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.27} stopColor="#fff" stopOpacity={0.62} />
          <stop offset={0.46} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.63} stopColor="#fff" stopOpacity={0.23} />
          <stop offset={0.78} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.91} stopColor="#fff" stopOpacity={0.03} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-26"
          cx={-4061.71}
          cy={4584.34}
          r={10.37}
          fx={-4061.71}
          fy={4584.34}
          gradientTransform="scale(-.98 .98)rotate(78.9 558.244 4707.343)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.06} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.21} stopColor="#fff" stopOpacity={0.66} />
          <stop offset={0.36} stopColor="#fff" stopOpacity={0.46} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.29} />
          <stop offset={0.64} stopColor="#fff" stopOpacity={0.16} />
          <stop offset={0.77} stopColor="#fff" stopOpacity={0.07} />
          <stop offset={0.89} stopColor="#fff" stopOpacity={0.02} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-27"
          cx={-4061.71}
          cy={4584.34}
          r={7.13}
          fx={-4061.71}
          fy={4584.34}
          gradientTransform="scale(-.98 .98)rotate(78.9 558.244 4707.343)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.08} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.27} stopColor="#fff" stopOpacity={0.62} />
          <stop offset={0.46} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.63} stopColor="#fff" stopOpacity={0.23} />
          <stop offset={0.78} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.91} stopColor="#fff" stopOpacity={0.03} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-28"
          cx={526.05}
          cy={5166.44}
          r={10.38}
          fx={526.05}
          fy={5166.44}
          gradientTransform="scale(.98 -.98)rotate(11.4 26426.858 480.147)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.06} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.21} stopColor="#fff" stopOpacity={0.66} />
          <stop offset={0.36} stopColor="#fff" stopOpacity={0.46} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.29} />
          <stop offset={0.64} stopColor="#fff" stopOpacity={0.16} />
          <stop offset={0.77} stopColor="#fff" stopOpacity={0.07} />
          <stop offset={0.89} stopColor="#fff" stopOpacity={0.02} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-29"
          cx={526.05}
          cy={5166.44}
          r={7.13}
          fx={526.05}
          fy={5166.44}
          gradientTransform="scale(.98 -.98)rotate(11.4 26426.858 480.147)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.08} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.27} stopColor="#fff" stopOpacity={0.62} />
          <stop offset={0.46} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.63} stopColor="#fff" stopOpacity={0.23} />
          <stop offset={0.78} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.91} stopColor="#fff" stopOpacity={0.03} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-30"
          cx={-331.68}
          cy={5831}
          r={10.37}
          fx={-331.68}
          fy={5831}
          gradientTransform="scale(.98 -.98)rotate(-11.1 -30336.097 441.15)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.06} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.21} stopColor="#fff" stopOpacity={0.66} />
          <stop offset={0.36} stopColor="#fff" stopOpacity={0.46} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.29} />
          <stop offset={0.64} stopColor="#fff" stopOpacity={0.16} />
          <stop offset={0.77} stopColor="#fff" stopOpacity={0.07} />
          <stop offset={0.89} stopColor="#fff" stopOpacity={0.02} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-31"
          cx={-331.62}
          cy={5831.02}
          r={7.13}
          fx={-331.62}
          fy={5831.02}
          gradientTransform="scale(.98 -.98)rotate(-11.1 -30336.146 442.206)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.08} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.27} stopColor="#fff" stopOpacity={0.62} />
          <stop offset={0.46} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.63} stopColor="#fff" stopOpacity={0.23} />
          <stop offset={0.78} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.91} stopColor="#fff" stopOpacity={0.03} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-32"
          cx={1064.17}
          cy={4224.2}
          r={10.37}
          fx={1064.17}
          fy={4224.2}
          gradientTransform="scale(.98 -.98)rotate(33.9 7596.36 467.238)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.06} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.21} stopColor="#fff" stopOpacity={0.66} />
          <stop offset={0.36} stopColor="#fff" stopOpacity={0.46} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.29} />
          <stop offset={0.64} stopColor="#fff" stopOpacity={0.16} />
          <stop offset={0.77} stopColor="#fff" stopOpacity={0.07} />
          <stop offset={0.89} stopColor="#fff" stopOpacity={0.02} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-33"
          cx={-1378.45}
          cy={6116.77}
          r={10.37}
          fx={-1378.45}
          fy={6116.77}
          gradientTransform="scale(.98 -.98)rotate(-33.6 -10830.717 454.597)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.06} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.21} stopColor="#fff" stopOpacity={0.66} />
          <stop offset={0.36} stopColor="#fff" stopOpacity={0.46} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.29} />
          <stop offset={0.64} stopColor="#fff" stopOpacity={0.16} />
          <stop offset={0.77} stopColor="#fff" stopOpacity={0.07} />
          <stop offset={0.89} stopColor="#fff" stopOpacity={0.02} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-34"
          cx={1064.17}
          cy={4224.2}
          r={7.13}
          fx={1064.17}
          fy={4224.2}
          gradientTransform="scale(.98 -.98)rotate(33.9 7596.36 467.238)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.08} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.27} stopColor="#fff" stopOpacity={0.62} />
          <stop offset={0.46} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.63} stopColor="#fff" stopOpacity={0.23} />
          <stop offset={0.78} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.91} stopColor="#fff" stopOpacity={0.03} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-35"
          cx={-1378.43}
          cy={6116.78}
          r={7.13}
          fx={-1378.43}
          fy={6116.78}
          gradientTransform="scale(.98 -.98)rotate(-33.6 -10830.708 454.692)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.08} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.27} stopColor="#fff" stopOpacity={0.62} />
          <stop offset={0.46} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.63} stopColor="#fff" stopOpacity={0.23} />
          <stop offset={0.78} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.91} stopColor="#fff" stopOpacity={0.03} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-36"
          cx={-4347.46}
          cy={3537.58}
          r={10.37}
          fx={-4347.46}
          fy={3537.58}
          gradientTransform="scale(-.98 .98)rotate(56.4 857.75 5729.874)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.06} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.21} stopColor="#fff" stopOpacity={0.66} />
          <stop offset={0.36} stopColor="#fff" stopOpacity={0.46} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.29} />
          <stop offset={0.64} stopColor="#fff" stopOpacity={0.16} />
          <stop offset={0.77} stopColor="#fff" stopOpacity={0.07} />
          <stop offset={0.89} stopColor="#fff" stopOpacity={0.02} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-37"
          cx={-4347.46}
          cy={3537.58}
          r={7.13}
          fx={-4347.46}
          fy={3537.58}
          gradientTransform="scale(-.98 .98)rotate(56.4 857.75 5729.874)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.08} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.27} stopColor="#fff" stopOpacity={0.62} />
          <stop offset={0.46} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.63} stopColor="#fff" stopOpacity={0.23} />
          <stop offset={0.78} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.91} stopColor="#fff" stopOpacity={0.03} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-38"
          cx={-3672.79}
          cy={1518.89}
          r={10.39}
          fx={-3672.79}
          fy={1518.89}
          gradientTransform="scale(-.98 .98)rotate(11.4 4616.104 18561.813)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.06} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.21} stopColor="#fff" stopOpacity={0.66} />
          <stop offset={0.36} stopColor="#fff" stopOpacity={0.46} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.29} />
          <stop offset={0.64} stopColor="#fff" stopOpacity={0.16} />
          <stop offset={0.77} stopColor="#fff" stopOpacity={0.07} />
          <stop offset={0.89} stopColor="#fff" stopOpacity={0.02} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-39"
          cx={-3672.77}
          cy={1518.89}
          r={7.13}
          fx={-3672.77}
          fy={1518.89}
          gradientTransform="scale(-.98 .98)rotate(11.4 4616.104 18561.813)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.08} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.27} stopColor="#fff" stopOpacity={0.62} />
          <stop offset={0.46} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.63} stopColor="#fff" stopOpacity={0.23} />
          <stop offset={0.78} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.91} stopColor="#fff" stopOpacity={0.03} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-40"
          cx={-2815.06}
          cy={854.3}
          r={10.37}
          fx={-2815.06}
          fy={854.3}
          gradientTransform="scale(-.98 .98)rotate(-11.1 -4745.578 -13401.077)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.06} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.21} stopColor="#fff" stopOpacity={0.66} />
          <stop offset={0.36} stopColor="#fff" stopOpacity={0.46} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.29} />
          <stop offset={0.64} stopColor="#fff" stopOpacity={0.16} />
          <stop offset={0.77} stopColor="#fff" stopOpacity={0.07} />
          <stop offset={0.89} stopColor="#fff" stopOpacity={0.02} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-41"
          cx={-2815.03}
          cy={854.3}
          r={7.13}
          fx={-2815.03}
          fy={854.3}
          gradientTransform="scale(.98 -.98)rotate(79.93 -713.764 2066.624)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.08} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.27} stopColor="#fff" stopOpacity={0.62} />
          <stop offset={0.46} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.63} stopColor="#fff" stopOpacity={0.23} />
          <stop offset={0.78} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.91} stopColor="#fff" stopOpacity={0.03} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-42"
          cx={-691.83}
          cy={705.14}
          r={10.37}
          fx={-691.83}
          fy={705.14}
          gradientTransform="scale(-.98 .98)rotate(-56.1 -867.005 -158.737)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.06} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.21} stopColor="#fff" stopOpacity={0.66} />
          <stop offset={0.36} stopColor="#fff" stopOpacity={0.46} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.29} />
          <stop offset={0.64} stopColor="#fff" stopOpacity={0.16} />
          <stop offset={0.77} stopColor="#fff" stopOpacity={0.07} />
          <stop offset={0.89} stopColor="#fff" stopOpacity={0.02} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-43"
          cx={-691.83}
          cy={705.13}
          r={7.13}
          fx={-691.83}
          fy={705.13}
          gradientTransform="scale(-.98 .98)rotate(-56.1 -866.937 -158.725)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.08} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.27} stopColor="#fff" stopOpacity={0.62} />
          <stop offset={0.46} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.63} stopColor="#fff" stopOpacity={0.23} />
          <stop offset={0.78} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.91} stopColor="#fff" stopOpacity={0.03} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-44"
          cx={250.4}
          cy={1243.25}
          r={10.37}
          fx={250.4}
          fy={1243.25}
          gradientTransform="scale(-.98 .98)rotate(-78.6 -565.081 872.082)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.06} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.21} stopColor="#fff" stopOpacity={0.66} />
          <stop offset={0.36} stopColor="#fff" stopOpacity={0.46} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.29} />
          <stop offset={0.64} stopColor="#fff" stopOpacity={0.16} />
          <stop offset={0.77} stopColor="#fff" stopOpacity={0.07} />
          <stop offset={0.89} stopColor="#fff" stopOpacity={0.02} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-45"
          cx={250.4}
          cy={1243.25}
          r={7.13}
          fx={250.4}
          fy={1243.25}
          gradientTransform="scale(-.98 .98)rotate(-78.6 -565.081 872.082)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.08} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.27} stopColor="#fff" stopOpacity={0.62} />
          <stop offset={0.46} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.63} stopColor="#fff" stopOpacity={0.23} />
          <stop offset={0.78} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.91} stopColor="#fff" stopOpacity={0.03} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-46"
          cx={1200.75}
          cy={3147.75}
          r={10.37}
          fx={1200.75}
          fy={3147.75}
          gradientTransform="scale(.98 -.98)rotate(56.4 3638.606 464.518)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.06} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.21} stopColor="#fff" stopOpacity={0.66} />
          <stop offset={0.36} stopColor="#fff" stopOpacity={0.46} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.29} />
          <stop offset={0.64} stopColor="#fff" stopOpacity={0.16} />
          <stop offset={0.77} stopColor="#fff" stopOpacity={0.07} />
          <stop offset={0.89} stopColor="#fff" stopOpacity={0.02} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-47"
          cx={1200.75}
          cy={3147.75}
          r={7.13}
          fx={1200.75}
          fy={3147.75}
          gradientTransform="scale(.98 -.98)rotate(56.4 3638.606 464.518)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.08} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.27} stopColor="#fff" stopOpacity={0.62} />
          <stop offset={0.46} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.63} stopColor="#fff" stopOpacity={0.23} />
          <stop offset={0.78} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.91} stopColor="#fff" stopOpacity={0.03} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-48"
          cx={-2454.89}
          cy={5980.2}
          r={10.37}
          fx={-2454.89}
          fy={5980.2}
          gradientTransform="scale(.98 -.98)rotate(-56.1 -6819.03 457.352)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.06} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.21} stopColor="#fff" stopOpacity={0.66} />
          <stop offset={0.36} stopColor="#fff" stopOpacity={0.46} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.29} />
          <stop offset={0.64} stopColor="#fff" stopOpacity={0.16} />
          <stop offset={0.77} stopColor="#fff" stopOpacity={0.07} />
          <stop offset={0.89} stopColor="#fff" stopOpacity={0.02} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-49"
          cx={-2454.82}
          cy={5980.22}
          r={7.13}
          fx={-2454.82}
          fy={5980.22}
          gradientTransform="scale(.98 -.98)rotate(-56.1 -6819.016 457.556)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.08} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.27} stopColor="#fff" stopOpacity={0.62} />
          <stop offset={0.46} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.63} stopColor="#fff" stopOpacity={0.23} />
          <stop offset={0.78} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.91} stopColor="#fff" stopOpacity={0.03} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-50"
          cx={-4061.71}
          cy={4584.34}
          r={10.37}
          fx={-4061.71}
          fy={4584.34}
          gradientTransform="scale(-.98 .98)rotate(78.9 558.244 4707.343)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.06} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.21} stopColor="#fff" stopOpacity={0.66} />
          <stop offset={0.36} stopColor="#fff" stopOpacity={0.46} />
          <stop offset={0.5} stopColor="#fff" stopOpacity={0.29} />
          <stop offset={0.64} stopColor="#fff" stopOpacity={0.16} />
          <stop offset={0.77} stopColor="#fff" stopOpacity={0.07} />
          <stop offset={0.89} stopColor="#fff" stopOpacity={0.02} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="The-daily-million_svg__radial-gradient-51"
          cx={-4061.71}
          cy={4584.34}
          r={7.13}
          fx={-4061.71}
          fy={4584.34}
          gradientTransform="scale(-.98 .98)rotate(78.9 558.244 4707.343)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.08} stopColor="#fff" stopOpacity={0.89} />
          <stop offset={0.27} stopColor="#fff" stopOpacity={0.62} />
          <stop offset={0.46} stopColor="#fff" stopOpacity={0.4} />
          <stop offset={0.63} stopColor="#fff" stopOpacity={0.23} />
          <stop offset={0.78} stopColor="#fff" stopOpacity={0.1} />
          <stop offset={0.91} stopColor="#fff" stopOpacity={0.03} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </radialGradient>
        <style>
          {
            ".The-daily-million_svg__cls-10{fill:#002812}.The-daily-million_svg__cls-53{fill:#fff}.The-daily-million_svg__cls-55{fill:#eac31b}"
          }
        </style>
      </defs>
      <circle
        cx={125.49}
        cy={125.42}
        r={125}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient)",
        }}
      />
      <circle
        cx={125.49}
        cy={125.42}
        r={125}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-2)",
        }}
      />
      <circle
        cx={125.49}
        cy={125.42}
        r={125}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-3)",
        }}
      />
      <path
        d="M125.75 211.8c-47.56 0-86.26-38.7-86.26-86.26s38.7-86.26 86.26-86.26 86.26 38.7 86.26 86.26-38.7 86.26-86.26 86.26"
        className="The-daily-million_svg__cls-55"
      />
      <circle
        cx={125.75}
        cy={125.54}
        r={82.43}
        style={{
          fill: "#018123",
        }}
      />
      <path
        d="M147.07 212.73a3.884 3.884 0 0 0-4.54-3.07c-2.1.41-3.47 2.44-3.07 4.54.41 2.1 2.44 3.47 4.54 3.07 2.1-.41 3.47-2.44 3.07-4.54M112.01 214.34c.43-2.1-.93-4.14-3.02-4.57-2.1-.43-4.14.93-4.57 3.02-.43 2.1.93 4.14 3.02 4.57 2.1.43 4.14-.93 4.57-3.02"
        className="The-daily-million_svg__cls-53"
      />
      <circle
        cx={200.32}
        cy={175.12}
        r={10.18}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-4)",
        }}
      />
      <circle
        cx={200.32}
        cy={175.12}
        r={7}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-5)",
        }}
      />
      <path
        d="M202.49 171.9a3.856 3.856 0 0 0-5.37 1.05 3.856 3.856 0 0 0 1.05 5.37c1.77 1.2 4.18.73 5.37-1.05 1.2-1.77.73-4.18-1.05-5.37"
        className="The-daily-million_svg__cls-53"
      />
      <circle
        cx={143.27}
        cy={213.47}
        r={10.18}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-6)",
        }}
      />
      <circle
        cx={143.27}
        cy={213.47}
        r={7}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-7)",
        }}
      />
      <path
        d="M147.07 212.73a3.884 3.884 0 0 0-4.54-3.07c-2.1.41-3.47 2.44-3.07 4.54.41 2.1 2.44 3.47 4.54 3.07 2.1-.41 3.47-2.44 3.07-4.54"
        className="The-daily-million_svg__cls-53"
      />
      <circle
        cx={108.22}
        cy={213.57}
        r={10.18}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-8)",
        }}
      />
      <circle
        cx={108.21}
        cy={213.57}
        r={7}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-9)",
        }}
        transform="rotate(-88.97 108.219 213.578)"
      />
      <path
        d="M112.01 214.34c.43-2.1-.93-4.14-3.02-4.57-2.1-.43-4.14.93-4.57 3.02-.43 2.1.93 4.14 3.02 4.57 2.1.43 4.14-.93 4.57-3.02"
        className="The-daily-million_svg__cls-53"
      />
      <circle
        cx={50.94}
        cy={175.54}
        r={10.18}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-10)",
        }}
      />
      <circle
        cx={50.94}
        cy={175.55}
        r={7}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-11)",
        }}
      />
      <path
        d="M53.07 178.76a3.87 3.87 0 0 0 1.09-5.37 3.87 3.87 0 0 0-5.37-1.09 3.87 3.87 0 0 0-1.09 5.37 3.87 3.87 0 0 0 5.37 1.09"
        className="The-daily-million_svg__cls-53"
      />
      <circle
        cx={37.44}
        cy={143.19}
        r={10.18}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-12)",
        }}
      />
      <circle
        cx={37.44}
        cy={143.19}
        r={7}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-13)",
        }}
      />
      <path
        d="M38.17 146.99c2.1-.41 3.47-2.44 3.07-4.54a3.884 3.884 0 0 0-4.54-3.07c-2.1.41-3.47 2.44-3.07 4.54.41 2.1 2.44 3.47 4.54 3.07"
        className="The-daily-million_svg__cls-53"
      />
      <circle
        cx={50.65}
        cy={75.72}
        r={10.18}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-14)",
        }}
      />
      <circle
        cx={50.65}
        cy={75.72}
        r={7}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-15)",
        }}
      />
      <path
        d="M48.49 78.93c1.77 1.2 4.18.73 5.37-1.05s.73-4.18-1.05-5.37-4.18-.73-5.37 1.05a3.856 3.856 0 0 0 1.05 5.37"
        className="The-daily-million_svg__cls-53"
      />
      <circle
        cx={75.37}
        cy={50.87}
        r={10.18}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-16)",
        }}
      />
      <circle
        cx={75.37}
        cy={50.87}
        r={7}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-17)",
        }}
      />
      <path
        d="M72.14 53a3.87 3.87 0 0 0 5.37 1.09 3.87 3.87 0 0 0 1.09-5.37 3.87 3.87 0 0 0-5.37-1.09A3.87 3.87 0 0 0 72.14 53"
        className="The-daily-million_svg__cls-53"
      />
      <circle
        cx={107.72}
        cy={37.36}
        r={10.18}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-18)",
        }}
      />
      <circle
        cx={107.72}
        cy={37.36}
        r={7}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-19)",
        }}
      />
      <path
        d="M103.91 38.1c.41 2.1 2.44 3.47 4.54 3.07 2.1-.41 3.47-2.44 3.07-4.54a3.884 3.884 0 0 0-4.54-3.07c-2.1.41-3.47 2.44-3.07 4.54"
        className="The-daily-million_svg__cls-53"
      />
      <circle
        cx={142.77}
        cy={37.26}
        r={10.18}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-20)",
        }}
      />
      <circle
        cx={142.77}
        cy={37.26}
        r={7}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-21)",
        }}
      />
      <path
        d="M138.97 36.48c-.43 2.1.93 4.14 3.02 4.57 2.1.43 4.14-.93 4.57-3.02.43-2.1-.93-4.14-3.02-4.57-2.1-.43-4.14.93-4.57 3.02"
        className="The-daily-million_svg__cls-53"
      />
      <circle
        cx={175.19}
        cy={50.58}
        r={10.18}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-22)",
        }}
      />
      <circle
        cx={175.18}
        cy={50.59}
        r={7}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-23)",
        }}
      />
      <path
        d="M171.98 48.42a3.856 3.856 0 0 0 1.05 5.37c1.77 1.2 4.18.73 5.37-1.05s.73-4.18-1.05-5.37-4.18-.73-5.37 1.05"
        className="The-daily-million_svg__cls-53"
      />
      <circle
        cx={200.04}
        cy={75.3}
        r={10.18}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-24)",
        }}
      />
      <circle
        cx={200.04}
        cy={75.3}
        r={7}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-25)",
        }}
      />
      <path
        d="M197.9 72.07a3.87 3.87 0 0 0-1.09 5.37 3.87 3.87 0 0 0 5.37 1.09 3.87 3.87 0 0 0 1.09-5.37 3.87 3.87 0 0 0-5.37-1.09"
        className="The-daily-million_svg__cls-53"
      />
      <circle
        cx={213.64}
        cy={142.69}
        r={10.18}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-26)",
        }}
      />
      <circle
        cx={213.64}
        cy={142.69}
        r={7}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-27)",
        }}
      />
      <path
        d="M214.42 138.9c-2.1-.43-4.14.93-4.57 3.02-.43 2.1.93 4.14 3.02 4.57 2.1.43 4.14-.93 4.57-3.02.43-2.1-.93-4.14-3.02-4.57"
        className="The-daily-million_svg__cls-53"
      />
      <circle
        cx={107.72}
        cy={37.36}
        r={10.18}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-28)",
        }}
      />
      <circle
        cx={107.72}
        cy={37.36}
        r={7}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-29)",
        }}
      />
      <path
        d="M103.91 38.1c.41 2.1 2.44 3.47 4.54 3.07 2.1-.41 3.47-2.44 3.07-4.54a3.884 3.884 0 0 0-4.54-3.07c-2.1.41-3.47 2.44-3.07 4.54"
        className="The-daily-million_svg__cls-53"
      />
      <circle
        cx={142.77}
        cy={37.26}
        r={10.18}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-30)",
        }}
      />
      <circle
        cx={142.77}
        cy={37.26}
        r={7}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-31)",
        }}
      />
      <path
        d="M138.97 36.48c-.43 2.1.93 4.14 3.02 4.57 2.1.43 4.14-.93 4.57-3.02.43-2.1-.93-4.14-3.02-4.57-2.1-.43-4.14.93-4.57 3.02"
        className="The-daily-million_svg__cls-53"
      />
      <circle
        cx={75.37}
        cy={50.87}
        r={10.18}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-32)",
        }}
      />
      <circle
        cx={175.19}
        cy={50.58}
        r={10.18}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-33)",
        }}
      />
      <circle
        cx={75.37}
        cy={50.87}
        r={7}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-34)",
        }}
      />
      <circle
        cx={175.18}
        cy={50.59}
        r={7}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-35)",
        }}
      />
      <path
        d="M72.14 53a3.87 3.87 0 0 0 5.37 1.09 3.87 3.87 0 0 0 1.09-5.37 3.87 3.87 0 0 0-5.37-1.09A3.87 3.87 0 0 0 72.14 53M171.98 48.42a3.856 3.856 0 0 0 1.05 5.37c1.77 1.2 4.18.73 5.37-1.05s.73-4.18-1.05-5.37-4.18-.73-5.37 1.05"
        className="The-daily-million_svg__cls-53"
      />
      <circle
        cx={200.32}
        cy={175.12}
        r={10.18}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-36)",
        }}
      />
      <circle
        cx={200.32}
        cy={175.12}
        r={7}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-37)",
        }}
      />
      <path
        d="M202.49 171.9a3.856 3.856 0 0 0-5.37 1.05 3.856 3.856 0 0 0 1.05 5.37c1.77 1.2 4.18.73 5.37-1.05 1.2-1.77.73-4.18-1.05-5.37"
        className="The-daily-million_svg__cls-53"
      />
      <circle
        cx={143.27}
        cy={213.47}
        r={10.18}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-38)",
        }}
      />
      <circle
        cx={143.27}
        cy={213.47}
        r={7}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-39)",
        }}
      />
      <circle
        cx={108.22}
        cy={213.57}
        r={10.18}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-40)",
        }}
      />
      <circle
        cx={108.21}
        cy={213.57}
        r={7}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-41)",
        }}
        transform="rotate(-88.97 108.219 213.578)"
      />
      <circle
        cx={50.94}
        cy={175.54}
        r={10.18}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-42)",
        }}
      />
      <circle
        cx={50.94}
        cy={175.55}
        r={7}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-43)",
        }}
      />
      <path
        d="M53.07 178.76a3.87 3.87 0 0 0 1.09-5.37 3.87 3.87 0 0 0-5.37-1.09 3.87 3.87 0 0 0-1.09 5.37 3.87 3.87 0 0 0 5.37 1.09"
        className="The-daily-million_svg__cls-53"
      />
      <circle
        cx={37.44}
        cy={143.19}
        r={10.18}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-44)",
        }}
      />
      <circle
        cx={37.44}
        cy={143.19}
        r={7}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-45)",
        }}
      />
      <path
        d="M38.17 146.99c2.1-.41 3.47-2.44 3.07-4.54a3.884 3.884 0 0 0-4.54-3.07c-2.1.41-3.47 2.44-3.07 4.54.41 2.1 2.44 3.47 4.54 3.07"
        className="The-daily-million_svg__cls-53"
      />
      <circle
        cx={50.65}
        cy={75.72}
        r={10.18}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-46)",
        }}
      />
      <circle
        cx={50.65}
        cy={75.72}
        r={7}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-47)",
        }}
      />
      <path
        d="M48.49 78.93c1.77 1.2 4.18.73 5.37-1.05s.73-4.18-1.05-5.37-4.18-.73-5.37 1.05a3.856 3.856 0 0 0 1.05 5.37"
        className="The-daily-million_svg__cls-53"
      />
      <circle
        cx={200.04}
        cy={75.3}
        r={10.18}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-48)",
        }}
      />
      <circle
        cx={200.04}
        cy={75.3}
        r={7}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-49)",
        }}
      />
      <path
        d="M197.9 72.07a3.87 3.87 0 0 0-1.09 5.37 3.87 3.87 0 0 0 5.37 1.09 3.87 3.87 0 0 0 1.09-5.37 3.87 3.87 0 0 0-5.37-1.09"
        className="The-daily-million_svg__cls-53"
      />
      <circle
        cx={213.64}
        cy={142.69}
        r={10.18}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-50)",
        }}
      />
      <circle
        cx={213.64}
        cy={142.69}
        r={7}
        style={{
          fill: "url(#The-daily-million_svg__radial-gradient-51)",
        }}
      />
      <path
        d="M214.42 138.9c-2.1-.43-4.14.93-4.57 3.02-.43 2.1.93 4.14 3.02 4.57 2.1.43 4.14-.93 4.57-3.02.43-2.1-.93-4.14-3.02-4.57"
        className="The-daily-million_svg__cls-53"
      />
      <path
        d="m73.84 144.61.79-3.38c-.26-.6-.18-1.27-.71-1.66L15.58 88.9l-.02 4.65 57.94 50.66c.13.13.26.2.33.33v.07ZM177.28 141.16l.79 3.38.33-.33 57.94-50.66-.03-4.66-49.85 43.62c-.53.46-8.93 8.05-9.2 8.65ZM129.47 178.25c-.66-.4-2.44-.75-3.17-.75s-2.17.27-2.83.67l-65.73 40.47v4.64l66.09-39.47c.66-.4 1.39-.6 2.12-.6s1.46.2 2.12.6l66.09 39.47v-4.64zM182.69 123.58l1.52-2.93-1.35-.33s-.69 3.06-.66 3.1.49.15.49.15Z"
        className="The-daily-million_svg__cls-10"
      />
      <path
        d="m74.82 143.61-17.08 75.04 66.08-39.43c.66-.39 1.39-.58 2.13-.58s1.47.19 2.13.58l66.08 39.43-17.08-75.04c-.34-1.49.17-3.05 1.31-4.05l57.92-50.67-76.64-6.94a4.16 4.16 0 0 1-3.44-2.5L125.95 8.71 95.66 79.46c-.6 1.4-1.92 2.36-3.44 2.5L15.58 88.9l57.92 50.67a4.13 4.13 0 0 1 1.31 4.05Z"
        className="The-daily-million_svg__cls-55"
      />
      <path
        d="M125.14 106.99v6.32l-2.5-5.59zM139.44 132.91l.39 13.42h-14.08l-1.18-6.58 3.73-4.5zM112.01 133.59v13.06l-11.36.6-.94-6.83 7.98-9.29z"
        className="The-daily-million_svg__cls-10"
      />
      <path
        d="m99.9 80.91-7.75 22.14s-.01-.05-.02-.09c-.01-.09-.04-.17-.05-.25s-.04-.17-.05-.25-.04-.17-.05-.25-.04-.17-.05-.25-.04-.17-.05-.25-.04-.17-.05-.25-.04-.17-.05-.25-.04-.17-.05-.25-.04-.17-.05-.25-.04-.17-.05-.25-.04-.17-.05-.25-.04-.17-.05-.25-.04-.17-.05-.25-.04-.17-.05-.25-.04-.17-.05-.25c-.54-3.16-1.9-5.89-4.01-8.01-2.79-2.81-6.62-4.29-11.1-4.29-1.62 0-3.32.2-5.05.6-4.68 1.08-9.38 2.32-14 3.69l-1.26.37v37.12l.11-.03v.24l.11-.03v.24l.11-.03v.24l.11-.03v.24l.11-.03v.24l.11-.03v.24l.11-.03v.12c-.59.17-1.19.34-1.77.52l-.66.21-.34.6c-2.85 4.88-5.7 9.85-8.5 14.8l-8.71-9.2-1.11.44c-3.01 1.21-6.03 2.5-8.97 3.83l-1.04.47v37.32l16.05 12.71 2.09-.95c2.6-1.18 5.27-2.31 7.92-3.37l.93-.37v-10.6l2.5 2.59.67.7.91-.34c1.25-.46 2.53-.91 3.8-1.36v.15l.11-.03v.18l.11-.03v.18l.11-.03v.18l.11-.03v.18l.11-.03v.18l.11-.03v.18l.11-.03v.18l.11-.03v.18l.11-.03v.18l.11-.03v.18l.11-.03v.18l.11-.03v.18l.11-.03v.18l.11-.03v.18l.11-.03v.18l.11-.03v.18l.11-.03v.18l.11-.03v.18l.11-.03v.18l.11-.03v.18l.11-.03v.18l.11-.03v.18l.11-.03v.18l.11-.03v.18l.11-.03v.18l.11-.03v.18l.11-.03v.18l.11-.03v.18l.11-.03v.18l.11-.03v.18l.11-.03v.18l.11-.03v.18l.11-.03v.18l1.93-.6c2.7-.84 5.45-1.64 8.18-2.36l1.1-.29v-1.38h.07v.16l.09-.02v.17l.09-.02v.17l.09-.02v.17l.09-.02v.17l.09-.02v.17l.09-.02v.17l.09-.02v.17l1.83-.45c3.07-.75 6.19-1.44 9.3-2.05l1.2-.23v-1.66h.07v.15h.07v.15h.07v.15h.07v.15h.07v.15h.07v.15h.07v.15h.07v.15H89v.15h.07v.15l1.74-.3c6.85-1.21 13.84-2.06 20.77-2.54l1.38-.09 1.42-.08c3.58-.19 7.21-.29 10.79-.29 3.35 0 6.75.09 10.1.26l1.44.07 1.37.09c3.14.21 6.32.49 9.45.84l1.65.19v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.16h.05v-.15c2.69 4.95 7.63 8.8 13.54 10.01 1.21.25 2.4.37 3.55.37 3.63 0 6.75-1.19 9.03-3.46.64-.63 1.19-1.33 1.65-2.09.03-.05.07-.11.1-.16s.07-.11.1-.16.07-.11.1-.16.07-.11.1-.16.07-.11.1-.16.07-.11.1-.16.07-.11.1-.16.07-.11.1-.16.07-.11.1-.16.07-.11.1-.16.07-.11.1-.16.07-.11.1-.16.07-.11.1-.16.07-.11.1-.16.07-.11.1-.16l.07-.1v11.16l1.06.32c2.72.81 5.46 1.68 8.13 2.6l1.97.68v-.18l.13.04v-.18l.13.04v-.18l.13.04v-.18l.13.04v-.18l.13.04V184l.13.04v-.18l.13.04v-.18l.13.04v-.18l.13.04v-.18l.13.04v-.18l.13.04v-.18l.13.04v-.18l.13.04v-.18l.13.04v-.18l.13.04v-.18l.13.04v-.18l.13.04v-.18l.13.04v-.18l.13.04v-.18l.13.04v-.18l.13.04v-.18l.13.04v-.18l.13.04v-.18l.13.04v-.18l.13.04v-.18l.13.04v-.18l.13.04v-.18h.01c1.12 2.03 2.24 4.06 3.34 6.08l.25.47.5.2c2.54 1.02 5.09 2.11 7.6 3.24l2.09.95 16.52-12.58-.47-37.44-1.04-.47.47.14c-3.15-1.42-6.36-2.79-9.56-4.07l-2.42-.97v.25l-.14-.05v.25l-.14-.05v.25l-.14-.05v.25l-.14-.05v.25l-.14-.05v.25l-.14-.05v.25l-.14-.05v.25l-.14-.05v.25l-.14-.05v.25l-.14-.05v.25l-.14-.05v.25l-.14-.05v.25l-.14-.05v.25l-.14-.05v.25l-.14-.05v.25l-.14-.05v.25l-.14-.05v.25l-.14-.05v.25l-.14-.05v.25l-.14-.05v.25l-.14-.05v.25l-.14-.05v.25l-.14-.05v.25l-.14-.05v.25l-.14-.05v.25l-.14-.05v.25l-.14-.05c-1.44-2.56-2.89-5.12-4.33-7.66l-.33-.58-.63-.22c-3.1-1.06-6.26-2.07-9.41-3.01l-2.26-.68v.23l-.11-.03v.23l-.11-.03v.23l-.11-.03v.23l-.11-.03v.23l-.11-.03v.23l-.11-.03v.23l-.11-.03v.23l-.11-.03v.23l-.11-.03v.23l-.11-.03v.23l-.11-.03v.23l-.11-.03v.23l-.11-.03v.23l-.11-.03v.23l-.11-.03v.23l-.11-.03v.23l-.11-.03v.23l-.11-.03v.23l-.11-.03v.23l-.11-.03v.23l-.11-.03v.23l-.11-.03v.23l-.11-.03v.23l-.11-.03v.23l-.11-.03v.23l-.11-.03v.23l-.11-.03v.23l-.11-.03v.23l-.11-.03v.23l-.11-.03v.04a25.9 25.9 0 0 0-5.83-6.66v-.17l.09.02v-.23l.09.02v-.23l.09.02v-.23l.09.02v-.23l.09.02v-.23l.09.02v-.23l.09.02v-.23l.09.02v-.23l.09.02v-.23l.09.02v-.23l.09.02v-.23l.09.02v-.23l.09.02v-.23l.09.02v-.23l.09.02v-6.22l.66-1.11h-.04l.15-.26h-.04l.15-.26H185l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26h-.04l.15-.26-2.17-.64c-3.7-1.1-7.48-2.12-11.24-3.03l-1.38-.34-.62 1.28c-1.11 2.28-2.22 4.58-3.32 6.88-1.17-3.01-2.35-6-3.53-8.99l-.35-.89-.95-.19c-3.93-.78-7.95-1.47-11.93-2.05l-3.28-.48.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.2-.03.15.3-.19-.03V90.1h.03v-.28h.05v-.28h.05v-.28h.05v-.28h.05v-.28h.05v-.28h.05v-.28h.05v-.28h.05v-.28h.05v-.28h.05v-.28h.05v-.28h.05v-.28h.05v-.28h.05v-.28h.05v-.28h.05v-.28h.05v-.28h.05v-.28h.05v-.28h.05v-.28h.05v-.28h.05v-.28h.05v-.28h.05v-.28h.05v-.28h.05v-.28h.05v-.28h.05v-.28l.85.12v-8.69l-1.81-.24v-.23h.05v-.3h.05v-.3h.05v-.3h.05v-.3h.05v-.3h.05v-.3h.05v-.3h.05v-.3h.05v-.3h.05v-.3h.05v-.3h.05v-.3h.05v-.3h.05v-.3h.05v-.3h.05v-.3h.05v-.3h.05v-.3h.05v-.3h.05v-.3h.05v-8.69l-1.55-.19c-5.15-.62-10.38-1.09-15.56-1.37l-1.01-.05-.36-.02-.5-.03-.83-.03c-2.3-.1-4.63-.17-6.92-.21l-1.79-.03v7.49h-.64v-7.46h-2.56c-2.3.03-4.62.07-6.92.15l-.7.03-.52.02-.48.02-.85.05c-5.96.27-11.98.77-17.9 1.49l-1.55.19V67l5.06 6.17v8.28Zm11.36 64.68-1.72.12c-2.42.17-4.84.38-7.27.62v-2.73h-.05v-.21h-.05v-.21h-.05v-.21h-.05v-.21h-.05v-.21h-.05v-.21h-.05v-.04c.92-.11 1.83-.23 2.75-.33l.99-.11 1.3-4.47c1.42-.14 2.84-.25 4.26-.36v8.6l.02-.03Zm13.31-34.47c-.33-.91-.67-1.81-1.01-2.72.34 0 .68-.01 1.01-.01zm13.22 28.37v.22h-.02v.22h-.02v.22h-.02v.22h-.02v.22h-.02v.22h-.02v.22h-.02v.22h-.02v.22h-.02v.22h-.02v.22h-.02v.22h-.02v.22h-.02v.22h-.02v2.9c-3.76-.18-7.58-.28-11.34-.28v-4.35h.13c3.15 0 6.33.09 9.48.25l1.56.08v-.22h.02v-.22h.02v-.22h.02v-.22h.02v-.22h.02v-.22h.02v-.22h.02v-.22h.02v-.22h.02v-.22h.02v-.22h.02v-.22h.02v-.22h.02v-.22h.02v-.22h.02v-.22h.02v-.22h.02v-.22h.02v-.22h.02v-.22h.02v-.22h.02v-.22h.02v-.22h.02v-.22 3.65-.06Zm17.08-41.82v-.09l.05.09zm0-.29v-.18l.09.19h-.09zm0-.28v-.28l.14.3z"
        className="The-daily-million_svg__cls-10"
      />
      <path
        d="M101.07 66.22c-1.17.13-2.34.26-3.49.4l-1.97.24v-8.7l1.55-.19c5.92-.72 11.94-1.22 17.9-1.49l1.84-.09v8.68l-1.68.08c-1.26.06-2.54.13-3.8.21v15.08l-1.64.11c-2.26.15-4.54.34-6.77.56l-1.93.19V66.23Z"
        className="The-daily-million_svg__cls-10"
      />
      <path
        d="M102.84 79.35c2.27-.23 4.54-.41 6.82-.57V63.7c1.83-.13 3.66-.23 5.48-.31v-5.15c-5.93.27-11.86.76-17.77 1.48v5.15q2.73-.33 5.46-.6v15.08Z"
        className="The-daily-million_svg__cls-53"
      />
      <path
        d="M136.34 80.21c-2.26-.1-4.56-.17-6.81-.21l-1.74-.03v-7.63h-1.49v7.62h-1.75c-2.26.03-4.56.07-6.81.15l-1.83.07V56.42l1.7-.06c2.29-.08 4.62-.13 6.92-.14h1.77v7.44h1.49V56.2l1.79.03c2.29.03 4.62.11 6.92.21l1.69.07v23.76l-1.84-.08Z"
        className="The-daily-million_svg__cls-10"
      />
      <path
        d="M124.53 70.59c1.68-.01 3.34 0 5.02.02v7.64q3.435.045 6.87.21V58.23c-2.28-.1-4.58-.17-6.87-.21v7.45c-1.68-.03-3.34-.03-5.02-.02V58c-2.29.01-4.58.06-6.87.14v20.23c2.29-.08 4.58-.13 6.87-.14z"
        className="The-daily-million_svg__cls-53"
      />
      <path
        d="M154.32 81.69c-5.07-.62-10.23-1.07-15.33-1.35l-1.67-.09V56.49l1.86.11c5.18.28 10.41.75 15.6 1.08l1.55.19-.04 8.99-1.03-.13v6.38l1.03.13v8.7l-1.97-.24Z"
        className="The-daily-million_svg__cls-10"
      />
      <path
        d="M154.53 74.79c-2.86-.34-5.72-.64-8.59-.88v-2.48c2.52.21 5.05.46 7.56.76v-5.15c-2.52-.29-5.04-.55-7.56-.76v-2.3c2.87.25 5.73.54 8.59.88v-5.15a235 235 0 0 0-15.44-1.36v20.23c5.16.28 10.31.74 15.44 1.36z"
        className="The-daily-million_svg__cls-53"
      />
      <path
        d="m56.8 91.77 1.26-.37c4.62-1.36 9.32-2.61 14-3.69 1.73-.4 3.42-.6 5.05-.6 4.47 0 8.31 1.48 11.1 4.29 2.8 2.82 4.28 6.72 4.27 11.27 0 10.4-7.88 19.2-19.62 21.91-4.6 1.07-9.24 2.28-13.79 3.63l-2.26.67V91.76Zm14.58 21.29c.07-.02.15-.03.23-.05 2.81-.65 5.41-2.1 5.41-8.22 0-2.62-.48-3.89-.89-4.51-.32-.48-.81-.97-2.09-.97-.48 0-1.03.07-1.64.21l-1.02.24z"
        className="The-daily-million_svg__cls-10"
      />
      <path
        d="M90.72 102.68c0-9.86-7.68-15.69-18.26-13.25-4.66 1.08-9.29 2.3-13.9 3.66v33.45c4.6-1.36 9.24-2.58 13.9-3.66 10.58-2.44 18.26-10.29 18.26-20.2m-21.1 12.62V98.37L72 97.8c4.52-1.05 6.77 1.07 6.77 6.99s-2.25 8.89-6.77 9.94z"
        className="The-daily-million_svg__cls-53"
      />
      <path
        d="M87.55 119.06c3.97-11.52 8.08-23.31 12.21-35.04l.37-1.05 1.11-.11c3.69-.38 7.44-.68 11.15-.89l1.3-.07.46 1.21c4.15 11.07 8.28 22.2 12.29 33.08l.87 2.36h-2.52c-3.9.03-7.85.15-11.73.36l-1.39.08-1.5-5.07c-2.25.15-4.52.34-6.76.55l-1.54 5.32-1.17.13c-3.72.4-7.49.9-11.2 1.48l-2.89.45.95-2.77h-.01Zm19.03-16.18.42-.03-.21-.69c-.07.25-.14.48-.21.73Z"
        className="The-daily-million_svg__cls-10"
      />
      <path
        d="M112.5 83.71c-3.7.21-7.38.5-11.07.89-4.08 11.57-8.15 23.25-12.21 35.03 3.75-.59 7.51-1.09 11.28-1.49.52-1.78 1.03-3.56 1.55-5.33 3.13-.32 6.27-.57 9.41-.76.5 1.7 1 3.38 1.5 5.08 3.93-.22 7.87-.33 11.81-.35-4.1-11.13-8.19-22.15-12.28-33.06Zm-8.33 21.14 2.58-8.84c.86 2.8 1.72 5.61 2.59 8.42-1.73.12-3.45.26-5.17.42"
        className="The-daily-million_svg__cls-53"
      />
      <path
        d="M137.6 118.82c-3.73-.19-7.53-.28-11.27-.28h-1.76V81.57h1.77c3.79 0 7.64.11 11.44.29l1.68.08v36.98l-1.85-.09Z"
        className="The-daily-million_svg__cls-10"
      />
      <path
        d="M126.33 116.78c3.79 0 7.57.1 11.35.29V83.62c-3.78-.19-7.57-.28-11.35-.29z"
        className="The-daily-million_svg__cls-53"
      />
      <path
        d="M166.39 122.04c-8.15-1.42-16.46-2.42-24.71-2.97l-1.64-.11V81.98l1.88.13c3.79.25 7.62.6 11.4 1.03l1.56.18v24.94c4.05.49 8.11 1.09 12.12 1.79l1.46.25v12.09l-2.07-.36Z"
        className="The-daily-million_svg__cls-10"
      />
      <path
        d="M141.79 83.86v33.45c8.33.56 16.65 1.56 24.9 2.99v-8.52c-4.51-.79-9.04-1.44-13.58-1.96V84.89c-3.77-.43-7.54-.77-11.32-1.03"
        className="The-daily-million_svg__cls-53"
      />
      <path
        d="M182.02 125.3c-3.64-.89-7.34-1.7-11.02-2.42l-1.42-.28v-13.02c-3.57-7.64-7.23-15.37-10.9-23l-1.44-2.99 3.28.48c3.99.58 8.48 1.37 12.29 1.76l.47.09.47 1.28c1.18 2.99 2.35 5.98 3.53 8.99l3.32-6.88.62-1.28 1.38.34c3.75.91 7.54 1.93 11.29 2.74l2.17.64-1.21 2.24c-3.6 6.07-7.19 12.16-10.66 18.12v13.73l-2.19-.54Z"
        className="The-daily-million_svg__cls-10"
      />
      <path
        d="M177.1 100.61c-1.66-4.27-3.33-8.52-5-12.75-3.93-.78-7.88-1.46-11.84-2.03 3.7 7.7 7.4 15.5 11.08 23.37v11.96c3.72.72 7.42 1.54 11.1 2.44v-11.96c3.65-6.27 7.28-12.45 10.9-18.54-3.7-1.09-7.42-2.1-11.16-3.01-1.69 3.49-3.38 7-5.08 10.53Z"
        className="The-daily-million_svg__cls-53"
      />
      <path
        d="m26.09 141.43 11.12-4.75s6.47 6.83 9.09 9.64c2.8-4.95 5.66-9.93 8.5-14.8l.34-.6.66-.21c2.85-.87 5.77-1.71 8.67-2.48l2.22-.59v37.1l-1.31.35c-3.24.86-6.52 1.81-9.73 2.81l-2.29.72v-11.63c-.93 1.62-1.87 3.23-2.79 4.85l-.33.58-.63.21c-1.76.6-3.53 1.23-5.26 1.87l-1.09.4-.8-.83c-.98-1.03-1.97-2.05-2.97-3.08v12.61l-1.11.44c-3.15 1.26-6.32 2.61-9.42 4.01l-2.49 1.13v-37.32l-.37-.44Z"
        className="The-daily-million_svg__cls-10"
      />
      <path
        d="M46.65 149.29q-4.785-5.145-9.51-10.08a256 256 0 0 0-8.91 3.8v33.45c3.14-1.42 6.3-2.77 9.49-4.04v-15.76c1.99 2.04 3.99 4.11 6 6.2 1.76-.65 3.53-1.28 5.3-1.89q3.03-5.295 6.09-10.5v15.76c3.25-1.02 6.52-1.96 9.81-2.83v-33.45c-2.88.77-5.75 1.59-8.6 2.46-3.24 5.56-6.46 11.18-9.67 16.88"
        className="The-daily-million_svg__cls-53"
      />
      <path
        d="m67.52 127.45 1.34-.33c3.7-.91 7.48-1.74 11.23-2.48l2.1-.41v37.04l-1.42.28c-3.7.72-7.42 1.54-11.07 2.44l-2.19.54v-37.08Z"
        className="The-daily-million_svg__cls-10"
      />
      <path
        d="M69.29 162.28c3.7-.91 7.42-1.73 11.15-2.46v-33.45c-3.73.73-7.45 1.55-11.15 2.46z"
        className="The-daily-million_svg__cls-53"
      />
      <path
        d="m83 124.1 1.46-.26c3.75-.66 7.57-1.24 11.34-1.72l1.99-.25v24.94c3.9-.46 7.85-.83 11.75-1.1l1.88-.13v12.05l-1.64.11c-8.25.57-16.56 1.58-24.71 3.01l-2.07.36v-37.02Z"
        className="The-daily-million_svg__cls-10"
      />
      <path
        d="M96.02 123.87c-3.76.48-7.52 1.05-11.26 1.7v33.45a240 240 0 0 1 24.89-3.04v-8.52c-4.56.31-9.11.75-13.64 1.33v-24.93Z"
        className="The-daily-million_svg__cls-53"
      />
      <path
        d="m111.26 120.66 1.67-.09c3.79-.21 7.64-.32 11.44-.35h1.77v24.93c3.99 0 8.03.11 12.01.31l1.68.09v12.05l-1.85-.09a238.59 238.59 0 0 0-24.84.05l-1.86.1v-36.98Z"
        className="The-daily-million_svg__cls-10"
      />
      <path
        d="M124.37 121.98c-3.79.03-7.57.14-11.35.34v33.45c8.34-.46 16.69-.47 25.03-.05v-8.52q-6.84-.345-13.68-.3v-24.93Z"
        className="The-daily-million_svg__cls-53"
      />
      <path
        d="M152.55 158.69c-3.72-.42-7.5-.76-11.24-1.01l-1.65-.11v-36.98l1.88.12c3.79.25 7.63.59 11.4 1.02l1.56.18v36.99l-1.96-.23Z"
        className="The-daily-million_svg__cls-10"
      />
      <path
        d="M141.42 155.93c3.78.25 7.56.58 11.32 1.01v-33.45c-3.77-.43-7.54-.76-11.32-1.01z"
        className="The-daily-million_svg__cls-53"
      />
      <path
        d="M177.2 162.87c-1.37 0-2.79-.15-4.22-.44-10.67-2.18-18.71-11.56-18.7-21.82 0-4.58 1.58-8.77 4.45-11.78 2.88-3.03 6.88-4.7 11.25-4.7 1.22 0 2.46.13 3.71.38 10.2 2.07 18.5 12.43 18.5 23.1 0 4.54-1.47 8.39-4.24 11.15-2.71 2.69-6.42 4.11-10.74 4.11Zm-4.98-25.86c-.76 0-1.24.28-1.64.99-.37.65-.81 1.95-.81 4.46 0 4.38 1.31 6.87 3.91 7.4.29.06.56.09.79.09 1.58 0 2.39-1.79 2.39-5.33 0-4.46-1.31-6.99-3.89-7.52-.26-.05-.52-.08-.75-.08Z"
        className="The-daily-million_svg__cls-10"
      />
      <path
        d="M173.32 126.24c-9.65-1.97-17.3 4.66-17.29 14.37 0 9.74 7.64 18.12 17.29 20.09 9.66 1.96 17.09-3.34 17.09-13.09s-7.44-19.42-17.09-21.38Zm0 25.34c-3.58-.72-5.32-3.95-5.32-9.13s1.74-7.81 5.32-7.09c3.57.74 5.3 4.09 5.3 9.25s-1.73 7.7-5.3 6.97"
        className="The-daily-million_svg__cls-53"
      />
      <path
        d="M222.95 178.07a231 231 0 0 0-9.03-3.85l-.59-.24-.3-.56c-2.62-4.81-5.3-9.64-7.99-14.43v11.84l-2.34-.81a247 247 0 0 0-9.67-3.1l-1.26-.38v-37.12l2.26.68c3.15.93 6.31 1.95 9.41 3.01l.63.22.33.58c2.68 4.7 5.36 9.48 8.01 14.26v-11.8l2.42.97c3.2 1.28 6.42 2.65 9.56 4.07l1.04.47v37.32l-2.49-1.13Z"
        className="The-daily-million_svg__cls-10"
      />
      <path
        d="M214.18 138.98v16.07c-3.74-6.85-7.51-13.6-11.3-20.26-3.1-1.06-6.21-2.05-9.34-2.99v33.45c3.26.97 6.51 2.01 9.74 3.12V152.3c3.79 6.66 7.56 13.42 11.3 20.28 3.05 1.23 6.09 2.52 9.1 3.88v-33.45c-3.14-1.42-6.3-2.77-9.49-4.04Z"
        className="The-daily-million_svg__cls-53"
      />
      <path
        d="m156.3 81.94-1.45 3.26-1.31-2.66.75-1.47h1.23zM189.99 133.81s-2.99 1.39-2.96 1.4 2.36 1.3 2.36 1.3l.59-2.7Z"
        className="The-daily-million_svg__cls-10"
      />
    </svg>
  );
};
export default SvgTheDailyMillion;
